module.exports = __webpack_public_path__ + "img/2-3.d31c2415.png";